export const dealsTableData = [
    {
        name: "Divibank - deal 1",
        principal: "5.5M USDC",
        fee: "13.6%", 
        region: "Brazil",
        assets: "Revenue-based financing",
    },
    {
        name: "A55 - deal 3",
        principal: "5M USDC",
        fee: "15%", 
        region: "Brazil",
        assets: "Revenue-based financing",
    },
    {
        name: "A55 - deal 2",
        principal: "3M USDC",
        fee: "15%", 
        region: "Brazil",
        assets: "Revenue-based financing",
    },
    {
        name: "Tecredi - deal 5",
        principal: "3M USDC",
        fee: "13%", 
        region: "Brazil",
        assets: "Asset-backed car loans",
    },
    {
        name: "Adiante - deal 1",
        principal: "3M USDC",
        fee: "15%", 
        region: "Brazil",
        assets: "Invoice advances",
    },
]